// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { WorkflowTemplateStepRequest } from './workflow-template-step-request';

/** See com.rev360.pms.api.controller.admin.encounter.CreateInterviewTemplateRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateInterviewTemplateRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Name must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	name!: string;

	@GandalfArray(WorkflowTemplateStepRequest)
	workflowStepTemplateRequests!: WorkflowTemplateStepRequest[] | null;

}
